import { replyTypes } from '../../data'
import { lang } from '../../assets/lang'
import { getSelectOptionsFromArrayOfObjects } from '../../utils/functions'

const isSequenceAddonAvailable = !!window.xitFlowBuilderData.sequence_addon

var isTeamAddonAvailable = !!window.xitFlowBuilderData.team_member_addon
var messenger_bot_connectivity_thirdparty_webhook = !!window.xitFlowBuilderData.messenger_bot_connectivity_thirdparty_webhook
var google_sheet_access = !!window.xitFlowBuilderData.google_sheet_access

var team_html_display_class = 'd-none';
if (isTeamAddonAvailable)
  team_html_display_class = '';

var thirdparty_webhook_display_class = 'd-none';
if(messenger_bot_connectivity_thirdparty_webhook)
  thirdparty_webhook_display_class = '';

var google_sheet_display_class = 'd-none';
if(google_sheet_access)
  google_sheet_display_class = '';

export let quickReplyHtml =
'<div class="form-group text-left mt-2">' + 
  '<label for="quick-reply-type">' + lang.quick_reply_html_label_reply_type + '</label>' +
  '<select id="quick-reply-type" class="form-control select2">' +
    '<option value="">' + lang.quick_reply_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(replyTypes) +
  '</select>' +
'</div>' +

'<div id="quick-reply-button-text-group" class="form-group text-left mt-2 d-none">' + 
  '<label for="quick-reply-button-text">' + lang.quick_reply_html_label_button_text + '</label>' +
  '<input type="text" class="form-control" id="quick-reply-button-text" aria-describedby="quick-reply-button-text-help">' +
'</div>' +

'<div id="quick-reply-postback-group" class="form-group text-left mt-2 d-none">' + 
  '<label for="quick-reply-postback">' + lang.quick_reply_html_label_postback_id + '</label>' +
  '<select id="quick-reply-postback" class="form-control select2">' +
    '<option value="">' + lang.quick_reply_html_title_select + '</option>' +
  '</select>' +
'</div>'

if(isSequenceAddonAvailable){
  quickReplyHtml += 
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-choose-label">' + lang.button_html_add_label + '</label>' +
        '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
      '</div>' + 
      '<select id="new-button-choose-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-remove-label">' + lang.button_html_remove_label + '</label>' +
      '</div>' + 
      '<select id="new-button-remove-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +
  '</div>' +
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-choose-sequence">' + lang.button_html_add_sequence + '</label>' +
      '<select id="new-button-choose-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-remove-sequence">' + lang.button_html_remove_sequence + '</label>' +
      '<select id="new-button-remove-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>'
}

quickReplyHtml += 
  '<div class="form-row '+ team_html_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-conversation-group">' + lang.button_html_conversation_group + '</label>' +
      '<select id="new-button-conversation-group" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-conversation-user">' + lang.button_html_conversation_user + '</label>' +
      '<select id="new-button-conversation-user" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>' +

  '<div class="form-row '+ thirdparty_webhook_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 col-12 d-none">' + 
      '<label for="reference-webhook-url">' + lang.button_html_label_webhook_url + '</label>' +
      '<input type="text" class="form-control" id="reference-webhook-url" aria-describedby="button-button-text-help">' +
    '</div>' +
  '</div>' +

  '<div class="form-row '+ google_sheet_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 col-12 d-none">' + 
      '<label for="quickreply-google-sheets">' + lang.button_html_google_sheet_add + '</label>' +
      '<select id="quickreply-google-sheets" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +
  '</div>'
